import { Component, Renderer } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { GeneratePassPage } from '../generate-pass/generate-pass';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { App } from 'ionic-angular/components/app/app';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import {	LoginProvider} from '../../providers/login/login';

@IonicPage()
@Component({
  selector: 'page-pass-purpose',
  templateUrl: 'pass-purpose.html',
})
export class PassPurposePage {
  resident_dashboard:any;

  constructor(public navCtrl: NavController, 
    private loginProvider: LoginProvider,
    public navParams: NavParams,
    private translate: TranslateService,
    private viewCtrl: ViewController,
    private storage :Storage,
    private renderer: Renderer,
    private app: App) {
      this.resident_dashboard={
				show_outstanding:true,
				show_icons:true,
				show_quick_icons:true,
				custom_icons:[],
				show_amenities: false,
				quick_icons_popup:{
          guest:1,
          Cab:1,
          delivery:1
        }
        

			  }
      this.renderer.setElementClass(viewCtrl.pageRef().nativeElement, 'popup', true);
   
    this.loginProvider.getSocietySettings().then(val => {
			
			if(val && val.society_data &&val['society_data'].data){
				var d = val['society_data'].data;
				if(d && typeof d == 'string'){
				   var	data = JSON.parse(d)
					if( data && data.resident_dashboard){
         
						this.resident_dashboard = data.resident_dashboard
					}
				}
			}
		  });
    console.log(this.resident_dashboard,'from pass purpose')
  }

  onSelect(name: string, icon: string){
    this.dismiss().then(val => {
      this.app.getRootNav().push(GeneratePassPage, {
        purpose: {
          name: name,
          icon: icon
        },
      });
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PassPurposePage');
  }

  dismiss() {
    return this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/pass-purpose/pass-purpose.ts